import { render, staticRenderFns } from "./core_columns.vue?vue&type=template&id=52ae43bf"
import script from "./core_columns.vue?vue&type=script&lang=js"
export * from "./core_columns.vue?vue&type=script&lang=js"
import style0 from "./core_columns.vue?vue&type=style&index=0&id=52ae43bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports